import { get, keyBy, omit } from 'lodash'
import {
  GET_GLOBAL_ITEM_REQUESTED,
  GET_GLOBAL_ITEM_SUCCEEDED,
  GET_GLOBAL_ITEM_FAILED,
  UPDATE_TOGGLE,
  GET_FILTERED_AND_PAGINATED_ITEMS_REQUESTED,
  GET_FILTERED_AND_PAGINATED_ITEMS_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_ITEMS_FAILED,
  UPDATE_GLOBAL_ITEM_REQUESTED,
  UPDATE_GLOBAL_ITEM_SUCCEEDED,
  UPDATE_GLOBAL_ITEM_FAILED,
  REMOVE_GLOBAL_ITEM_SUCCEEDED,
  CREATE_GLOBAL_ITEM_REQUESTED,
  CREATE_GLOBAL_ITEM_SUCCEEDED,
  CREATE_GLOBAL_ITEM_FAILED,
  SEARCH_GLOBAL_ITEM_SUCCEEDED,
  ADD_ITEM_FILTERS_BY_MENU,
  ADD_ITEM_FILTERS_BY_CATEGORY,
  ADD_ITEM_FILTERS_BY_INVENTORY_STATE,
  SET_ITEMS_INDEXES,
  CLEAR_ITEMS_INDEXES,
  SET_ITEMS_PAGINATION_CONFIG,
} from './constants'
import { SEARCH_BAR_ITEMS_OPTIONS } from 'resources'

export const defaultState = {
  itemsIndexes: [],
  toggle: {
    allMenusAccess: false,
    allStandsAccess: false,
  },
  isLoading: false,
  filters: {
    byCategory: [],
    byInventoryState: [],
    byMenu: [],
    searchGlobalItemValue: null,
  },
  pagination: {
    config: {
      per: 25,
      page: 1,
      searchBy: SEARCH_BAR_ITEMS_OPTIONS[0].uuid,
      searchFor: '',
    },
  },
}

const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    case CREATE_GLOBAL_ITEM_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case CREATE_GLOBAL_ITEM_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId,
        },
        isLoading: false,
      }
    }

    case CREATE_GLOBAL_ITEM_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case GET_GLOBAL_ITEM_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case GET_GLOBAL_ITEM_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        byId,
        isLoading: false,
      }
    }

    case GET_GLOBAL_ITEM_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case GET_FILTERED_AND_PAGINATED_ITEMS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case GET_FILTERED_AND_PAGINATED_ITEMS_SUCCEEDED: {
      const { headers, data } = payload

      const total = Number(headers.total ?? 0)
      const byId = keyBy(data?.items, 'uuid')

      return {
        ...state,
        pagination: {
          ...state.pagination,
          byId,
          total,
        },
        isLoading: false,
      }
    }

    case GET_FILTERED_AND_PAGINATED_ITEMS_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case SET_ITEMS_PAGINATION_CONFIG: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          config: payload,
        },
      }
    }

    case REMOVE_GLOBAL_ITEM_SUCCEEDED: {
      const editedState = omit(state.byId, payload)

      return {
        ...state,
        byId: editedState,
      }
    }

    case UPDATE_GLOBAL_ITEM_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }

    case UPDATE_GLOBAL_ITEM_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')
      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId,
        },
        isLoading: false,
      }
    }

    case UPDATE_GLOBAL_ITEM_FAILED: {
      return {
        ...state,
        isLoading: false,
      }
    }

    case UPDATE_TOGGLE: {
      const key = get(payload, 'key')
      const value = get(payload, 'value')

      return {
        ...state,
        toggle: {
          ...state.toggle,
          [key]: value,
        },
      }
    }

    case SEARCH_GLOBAL_ITEM_SUCCEEDED:
      return {
        ...state,
        filters: {
          ...state.filters,
          searchGlobalItemValue: payload,
        },
      }

    case ADD_ITEM_FILTERS_BY_MENU:
      return {
        ...state,
        filters: {
          ...state.filters,
          byMenu: [...payload],
        },
      }

    case ADD_ITEM_FILTERS_BY_CATEGORY:
      return {
        ...state,
        filters: {
          ...state.filters,
          byCategory: [...payload],
        },
      }

    case ADD_ITEM_FILTERS_BY_INVENTORY_STATE:
      return {
        ...state,
        filters: {
          ...state.filters,
          byInventoryState: [...payload],
        },
      }

    case SET_ITEMS_INDEXES: {
      const uuids = payload.map((payloadItem) => payloadItem.uuid)
      const itemWithoutDuplicatedItems = state.itemsIndexes.filter(
        (item) => {
          return !uuids.includes(item.uuid)
        }
      )

      return {
        ...state,
        itemsIndexes: [...itemWithoutDuplicatedItems, ...payload],
      }
    }

    case CLEAR_ITEMS_INDEXES:
      return {
        ...state,
        itemsIndexes: [],
      }

    default:
      return state
  }
}

export default state
